import React, { FunctionComponent, useEffect, useMemo } from 'react';
import spamUsers, {
  getList,
  reset as resetSpamUsers,
  DEFAULT_SPAM_USERS_SORT,
  DEFAULT_SPAM_USERS_FILTERS,
} from '@stores/spamUsers/spamUsers';
import localeWeightSpamUsers, {
  resetLocaleWeightSpamUsers,
  LOCALE,
} from '@stores/spamUsers/localeWeightSpamUsers';
import SpamUsersFilters from '@components/SpamUsersFilters';
import SpamUsersList from '@components/SpamUsersList';
import SpamPageLayout from '@components/SpamPageLayout';
import { useStore } from 'effector-react';

interface UsersSpamRouteProps {}

const UsersSpamRoute: FunctionComponent<UsersSpamRouteProps> = () => {
  const { filters } = useStore(spamUsers);
  const locale = useStore(localeWeightSpamUsers);

  useEffect(() => {
    getList({
      filters: DEFAULT_SPAM_USERS_FILTERS,
      sort: DEFAULT_SPAM_USERS_SORT,
    });

    return () => {
      resetSpamUsers();
      resetLocaleWeightSpamUsers();
    };
  }, []);

  const hasActiveFilters = useMemo(() => {
    const currentSort = Array.isArray(filters.sort) ? filters.sort : DEFAULT_SPAM_USERS_SORT;

    const hasCustomSort =
      currentSort.length !== DEFAULT_SPAM_USERS_SORT.length ||
      currentSort.some((item, index) => item !== DEFAULT_SPAM_USERS_SORT[index]);

    return Boolean(
      filters.nickname ||
        filters.createdFrom ||
        filters.createdTo ||
        filters.checkedType === 'CHECKED' ||
        filters.showBlocked === true ||
        filters.hideUnblocked === true ||
        hasCustomSort ||
        locale !== LOCALE.ALL,
    );
  }, [filters, locale]);

  return (
    <SpamPageLayout
      filters={<SpamUsersFilters />}
      hasActiveFilters={hasActiveFilters}
    >
      <SpamUsersList />
    </SpamPageLayout>
  );
};

export default UsersSpamRoute;
